"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.youtubeSearch = exports.youtubeSearchResultSchema = exports.youtubeSearchArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.youtubeSearchArgsSchema = zod_1.z.object({
    query: zod_1.z.string().describe('The YouTube search query'),
    options: zod_1.z
        .object({
        numResults: zod_1.z.number().min(1).max(50).nullish(),
        order: zod_1.z.enum(['relevance', 'date', 'rating', 'viewCount', 'title', 'videoCount']).nullish(),
        videoDuration: zod_1.z.enum(['any', 'short', 'medium', 'long']).nullish(),
        publishedAfter: zod_1.z.string().nullish(),
        publishedBefore: zod_1.z.string().nullish(),
        failIfEmpty: zod_1.z
            .boolean()
            .default(true)
            .describe('Fail if the search returns no results. Default to true.'),
    })
        .describe('Search options'),
    emitMode: common_1.emitModeSchema.default('multi').describe('The mode to emit the search results in.'),
});
exports.youtubeSearchResultSchema = zod_1.z.object({
    results: zod_1.z.array(zod_1.z.object({
        title: zod_1.z.string(),
        description: zod_1.z.string(),
        videoId: zod_1.z.string(),
        channel: zod_1.z.string(),
    })),
});
exports.youtubeSearch = (0, common_1.createEmitModeToolMetadata)({
    id: 'youtubeSearch',
    displayName: 'YouTube Search',
    displayDescription: 'Search for YouTube videos.',
    category: 'search',
    color: common_1.BRAND_COLORS.YOUTUBE,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.YOUTUBE),
    icon: 'youtube',
    argsSchema: exports.youtubeSearchArgsSchema,
}, exports.youtubeSearchResultSchema);
